// extracted by mini-css-extract-plugin
export default {"epgContainerInner":"styles_epgContainerInner__Yd5yn","epgCurrentValues":"styles_epgCurrentValues__mPs08","currentPlaying":"styles_currentPlaying__HW3JC"};